// extracted by mini-css-extract-plugin
export var ContainerStyles = "Container-module--ContainerStyles--1tthH";
export var ContentContainer = "Container-module--ContentContainer--N1t_N";
export var Pattern2 = "Container-module--Pattern2--2p-zu";
export var Pattern1 = "Container-module--Pattern1--2tjvS";
export var Pattern0 = "Container-module--Pattern0--3_jk0";
export var Pattern3 = "Container-module--Pattern3--2daLd";